import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import {
  VerticalMenu,
  VerticalMenuItem,
  Hero,
  Tile,
} from '@storaensods/seeds-react'
import get from 'lodash/get'
import { TabBar, TabItem } from '@storaensods/seeds-react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Layout from '../components/layout'
import PageTabs from '../components/page-tabs'
import { renderRichText } from '../utils'
import styles from './brand-asset.module.css'
import './brand-asset.css';

class BrandAssetTemplate extends React.Component {

  constructor(props){
    super(props);
    this.state = {currentUrl:null}
  }

  componentDidMount(){
    this.setState({currentUrl: window.location.href});
  }

  checkActiveSubItem(subItems) {  
    let hasActiveSubItem = false;
    if(subItems && this.state.currentUrl){
    
    for (var subItem of subItems) {      
      if (this.state.currentUrl.includes(subItem.url)) {
        hasActiveSubItem = true;
      }
    }
  } 
    return hasActiveSubItem;
  }

  render() {
    
    const tabs = get(this.props, 'data.tabs.edges');
    const pictograms = get(this.props, 'data.pictogramAndText.edges');   
    const options = {
      tabs: node => {
        const title = get(node, 'data.target.fields.title.en-US')
        const tab = tabs.find(({ node }) => node.title === title)
        return (
          <React.Fragment>
            {tab && (
              <PageTabs
                tab={tab}
                activeTab={tab.node.items ? tab.node.items[0].id : ''}
              />
            )}
          </React.Fragment>
        )
      },
      pictogramAndText: node => {          
        const titlePictogram = get(node, 'data.target.fields.title.en-US');
        const pictogramAndText = pictograms.find(({ node }) => node.title === titlePictogram)
        return (
          <div className={styles.pictogramWrapper}>
            <div className={styles.pictogramImage}>{pictogramAndText.node.pictogram && renderRichText(pictogramAndText.node.pictogram.json)}</div>
           <div className={styles.pictogramText}>{pictogramAndText.node.text && documentToReactComponents(pictogramAndText.node.text.json)}</div>
          </div>
        )
      },
    }


    const navigation = get(this.props, 'data.navigation')
    const page = get(this.props, 'data.page')    

    let heroBackgroundImage;
    page.heroImage ? heroBackgroundImage = page.heroImage.resolutions.src : heroBackgroundImage = "none";

    return (
      <Layout location={this.props.location}>
        <Helmet title={` | Brand Assets | Stora Enso Design System`} >
        <script async src={`https://www.googletagmanager.com/gtag/js?id=UA-157026851-1`} />
        <script>
        {`
           window.dataLayer = window.dataLayer || [];
           function gtag(){dataLayer.push(arguments);}
           gtag('js', new Date());
           gtag('config', 'UA-157026851-1');
        `}
        </script> 
        </Helmet>
        <div className="row no-gutters se-fullheight">
          <div className="col-12 col-sm-4 col-lg-2">
            <VerticalMenu color="light">
              {navigation &&
                navigation.items.map(item => (
                  
                  <VerticalMenuItem
                    key={item.title}
                    label={item.title}
                    isExpanding={item.subItems}
                    isOpen={this.checkActiveSubItem(item.subItems)}
                    href={item.url}
                    isActive={this.state.currentUrl && this.state.currentUrl.includes(item.url)}
                  >
                  
                    {item.subItems &&
                      item.subItems.map(subItem => (
                        <VerticalMenuItem
                          isOpen={this.checkActiveSubItem(subItem.subItems)}
                          key={subItem.title}
                          label={subItem.title}
                          href={subItem.url}
                          isActive={this.state.currentUrl && this.state.currentUrl.includes(subItem.url)}
                        />
                      ))}
                  </VerticalMenuItem>
                ))}
            </VerticalMenu>
          </div>
          <div className="col-12 col-sm-8 col-lg-10">
            <Hero color="gray" size={page.heroImage ? "md" : "sm"} 
             style={{"backgroundImage":"url("+heroBackgroundImage+")"}}>
              <Tile color="yellow">
                {page && renderRichText(page.heroText.json)}
              </Tile>
            </Hero>
            <div className={'se-pl-xl se-pr-xl ' + styles.brandAssetsContent}>
            <div className="maxWidthLimit showBullets">{page.content && renderRichText(page.content.json, options)}</div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default BrandAssetTemplate

export const pageQuery = graphql`
  query BrandAssetBySlug($slug: String!) {
    page: contentfulPage(slug: { eq: $slug }) {
      heroText {
        json
      }       
      heroImage {
        resolutions(width: 1280) {
          src
        }
      }
      content {
        json
      }
    }
    navigation: contentfulNavigation(title: { eq: "Brand Assets Navigation" }) {
      title
      items {
        title
        url
        subItems {
          title
          url
          openLinkInNewWindow
        }
        openLinkInNewWindow
      }
    }
    tabs: allContentfulTabs {
      edges {
        node {
          title
          items {
            id
            label
            content {
              json
            }
          }
        }
      }
    }
    pictogramAndText: allContentfulPictogramAndText {
      edges {
        node {
          title
          pictogram {          
            json
          }
          text {
            json
          }
        }
      }
    }
  }
`
